import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function PublicationsSeriesFilter({
  addFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="series"
      filters={filters}
      formHint="Select all that apply."
      id="series"
      label="Series"
      orderByCount={false}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(PublicationsSeriesFilter);
